// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  droidId: __t.u64().primaryKey().name("droid_id"),
  owner: __t.identity(),
  codeJson: __t.string().name("code_json"),
  stateJson: __t.string().name("state_json"),
  line: __t.u32(),
  status: __t.string(),
  err: __t.string(),
  compiledAt: __t.timestamp().name("compiled_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
